/**
 * SINGLE SOURCE OF TRUTH for the frontend production site URL.
 *
 * - The production base URL comes from ONE configuration value: REACT_APP_SITE_URL.
 * - The host MUST be `moveabroadiq.com`. Any other host (preview / staging /
 *   localhost / deployment URL) is REJECTED and the production URL is forced,
 *   so a canonical can NEVER be emitted on a non-production host.
 * - Canonicals are ALWAYS self-referencing on the production host.
 * - NEVER derive the base from window.location.origin.
 */
export const PRODUCTION_HOST = 'moveabroadiq.com';
const PRODUCTION_URL = `https://${PRODUCTION_HOST}`;

const _configured = (process.env.REACT_APP_SITE_URL || PRODUCTION_URL).replace(/\/+$/, '');

let _resolved = PRODUCTION_URL;
try {
  if (new URL(_configured).hostname === PRODUCTION_HOST) {
    _resolved = _configured;
  } else if (typeof console !== 'undefined') {
    console.warn(`[siteConfig] REACT_APP_SITE_URL '${_configured}' is not the production host '${PRODUCTION_HOST}' — forcing ${PRODUCTION_URL}.`);
  }
} catch (e) {
  /* invalid URL — keep production */
}

export const SITE_URL = _resolved;

/** Build a production, self-referencing canonical for a path (pathname only). */
export const canonicalUrl = (pathname) => SITE_URL + (pathname || '/').replace(/\/+$/, '');
